import { RecordOf } from '@opengov/compose-app/immutable';

import { IUser } from '../types';

export const User = RecordOf<IUser>({
  id: null,
  first_name: null,
  last_name: null,
  full_name: null,
  email: null,
  uuid: null
});
